export const temaClaro = {
  PRIMARY: '#4b7bec',
  PRIMARY_DARKER: '#3e65c2',
  SECONDARY: '#C3D940',
  SECONDARY_DARKER: '#b4c83b',
  INFO: '#4179d1',
  INFO_DARKER: '#3c6fc1',
  SUCCESS: '#05a300',
  SUCCESS_DARKER: '#036500',
  DANGER: '#c30000',
  DANGER_DARKER: '#820000',
  WARNING: '#FFA502',
  WARNING_DARKER: '#eb9801',
  LIGHT: '#fff',
  MEDIUM: '#ededed',
  BACKGROUND: '#d3d3d3',
  BACKGROUND_DARKER: '#c3c2c2',
  DARK: '#000',
  DARK_DARKER: '#040E25',
};
